import { Box, Button, Dialog, DialogContent, Typography } from "@mui/material"
import { BoxFC, BoxFR } from "components/BoxCustom"
import PaperComponent from "components/PaperComponent"
import { DialogFooter, DialogHeader } from "components/dialog/DialogHeader"
import { GlobalStateContext } from "contexts/GlobalStateContext"
import React, { useCallback, useContext, useEffect, useMemo, useState } from "react"
import { addExpTableColumns } from "./columns"
import { addSumRow, getSumColorClassName, sxSumColorClass } from "utils/highlightSumColor"
import DataGridCellExpand from "components/DataGridCellExpand/DataGridCellExpand"
import { blue, blueGrey, green } from "@mui/material/colors"
import { AddCircleRounded } from "resource/muiImport"
import ComboBox from "components/ComboBox"
import { alertError } from "components/Alert"
import { ACC_TYP_EMP } from "constants/accountConstant"
import { UserContext } from "contexts/UserContext"
import { useGridApiRef } from "@mui/x-data-grid-pro"
import { timeout } from "utils/timeout"

const AddExpenseTableDialog = ({ dialogOpen, setDialogOpen, onFinish, jobOrdIds, joData, isFromSubcontract
  , excludeExpIds = [], usedExpIds = [] }) => {

  const { user } = useContext(UserContext)
  const { msData } = useContext(GlobalStateContext)
  const apiRef = useGridApiRef()
  const [dataTable, setDataTable] = useState([])
  const [expId, setExpId] = useState(null)


  const modDataTable = useMemo(() => {
    return addSumRow({
      dataTable: dataTable,
      sumColNms: ["Amnt", "PayAmnt"],
      sumColTotal: "ExpNm"
    })
  }, [dataTable])

  const favExp = useMemo(() => {
    let list = user.AccTypId === ACC_TYP_EMP ? msData.expCombo.filter(item => item.isFav) : msData.expCombo
    if (excludeExpIds.length > 0) list = list.filter(item => !excludeExpIds.includes(item.id))
    return list
  }, [msData.expCombo, user.AccTypId, excludeExpIds])

  const nonFavExp = useMemo(() => {
    let list = user.AccTypId === ACC_TYP_EMP ? msData.expCombo.filter(item => !item.isFav) : msData.expCombo
    if (excludeExpIds.length > 0) list = list.filter(item => !excludeExpIds.includes(item.id))
    return list
  }, [msData.expCombo, user.AccTypId, excludeExpIds])

  const handleEditCommit = useCallback((params) => {


    setDataTable(o => {
      const result = [...o]
      const foundIndex = result.findIndex(r => r.id === params.id)
      result[foundIndex][params.field] = params.value
      const { UntPr, VatPrct, Qty } = result[foundIndex]
      let untPr = UntPr
      let untPrB4Vat = untPr / (1 + (VatPrct / 100))
      let total = untPr * Qty
      if (params.field === "UntPr") {
        untPr = params.value
        untPrB4Vat = untPr / (1 + (VatPrct / 100))
      } else if (params.field === "UntPrB4Vat") {
        untPrB4Vat = params.value
        untPr = untPrB4Vat * (1 + (VatPrct / 100))
      } else if (params.field === "VatPrct") {
        untPr = UntPr
        untPrB4Vat = untPr / (1 + (VatPrct / 100))
      }
      total = untPr * Qty
      let whtPayrTyp = result[foundIndex].WhtPayrTyp
      let whtTypId = result[foundIndex].WhtTypId
      if (params.field === "WhtPrct") {
        if (params.value > 0) {
          if (!whtPayrTyp) whtPayrTyp = +result[foundIndex].IsOwnRcpt === 1 ? "O" : "A"
          if (!whtTypId) whtTypId = params.value === 1 ? 1 : 5
        } else {
          whtPayrTyp = null
          whtTypId = null
        }
      }
      result[foundIndex] = {
        ...result[foundIndex], [params.field]: params.value,
        UntPr: untPr,
        UntPrB4Vat: untPrB4Vat,
        Total: total,
        WhtPayrTyp: whtPayrTyp,
        WhtTypId: whtTypId,
      }
      // const rowId0 = result.find(row => row.id === 0)
      // if(row)
      // rowId0.PayAmnt = result.reduce((acc, row) => acc + +row.PayAmnt, 0)
      return result
    })
  }, [])

  const handleAddExp = useCallback(async (expObj) => {

    if (usedExpIds.includes(expObj.id)) {
      alertError("ค่าใช้จ่ายนี้มีอยู่ในใบงานที่เลือกแล้ว ไม่สามารถเพิ่มซ้ำได้")
      return
    }
    if (dataTable.some(r => r.ExpId === expObj.id)) {
      alertError("ค่าใช้จ่ายนี้ถูกเพิ่มในรายการแล้ว")
      return
    }

    setDataTable(o => {
      const result = [...o]
      if (joData && isFromSubcontract) {
        const found = msData.expensePOIs?.find(exp => (!exp.ExpId || exp.ExpId === expObj.id)
          && (!exp.JobId || exp.JobId === joData.JobId)
          && (!exp.POIId || [joData.TakePOIId, joData.LocPOIId, joData.RtnPOIId].includes(exp.POIId))
          && (!exp.ContSize || exp.ContSize === joData.ContSize)
          && (!exp.ContType || exp.ContType === joData.ContType)
          && (!exp.ShpmTypId || exp.ShpmTypId === joData.ShpmTypId)
          && (!exp.TlrTypId || exp.TlrTypId === joData.TlrTypId)
        )



        const resultObj = {
          id: result.length + 1,
          No: result.length + 1,
          ExpId: expObj.id,
          ExpNm: expObj.label,
          Rmk: "",
          Qty: 1,
          IsLoading: false,
        }
        if (found) {
          const untPr = +(found?.UntPr || 0)
          const vatPrct = +(found?.VatPrct || 0)
          const whtPrct = +(found?.WhtPrct || 0)
          const isOwnRcpt = +(found?.IsOwnRcpt || 0)

          result.push({
            ...resultObj,
            IsOwnRcpt: isOwnRcpt,
            UntPr: untPr,
            VatPrct: vatPrct,
            WhtPrct: whtPrct,
            WhtPayrTyp: whtPrct > 0 ? (isOwnRcpt === 1 ? "O" : "A") : null,
            WhtTypId: whtPrct > 0 ? (whtPrct === 1 ? 1 : 5) : null,
          })
        } else {
          const expData = msData.expObj[expObj.id]
          if (expData) {
            const expWhtPrct = +expData.WhtPrct
            result.push({
              ...resultObj,
              IsOwnRcpt: expData.IsOwnRcpt,
              UntPr: +expData.UntPr,
              VatPrct: +expData.VatPrct,
              WhtPrct: expWhtPrct,
              WhtPayrTyp: expWhtPrct > 0 ? (+expData.IsOwnRcpt === 1 ? "O" : "A") : null,
              WhtTypId: expWhtPrct > 0 ? (expWhtPrct === 1 ? 1 : 5) : null,
            })
          }
        }
      } else {
        const foundExp = msData.expenses.find(item => item.ExpId === expObj.id)
        if (foundExp) {
          result.push({
            ...foundExp,
            id: result.length + 1,
            No: result.length + 1,
            Rmk: "",
            Qty: 1,
            IsLoading: false,
          })
        } else {
          result.push({
            id: result.length + 1,
            No: result.length + 1,
            IsOwnRcpt: 0,
            ExpId: expObj.id,
            ExpNm: expObj.label,
            Rmk: "",
            UntPr: 0,
            Qty: 1,
            VatPrct: 0,
            WhtPrct: 0,
            IsLoading: false,
          })
        }
      }


      return result
    })
  }, [joData, isFromSubcontract, msData.expensePOIs, msData.expObj, msData.expenses, usedExpIds, dataTable])

  const handleAddFromCombo = useCallback(() => {
    if (expId) {
      const expObj = msData.expCombo.find(exp => exp.id === expId)
      handleAddExp(expObj)
    }
  }, [msData.expCombo, expId, handleAddExp])

  const handleRemoveRow = useCallback((row) => {
    setDataTable(o => o.filter(r => r.id !== row.id))
  }, [])

  const handleChangeIsOwnRcpt = useCallback((id) => {

    setDataTable(o => {
      const result = [...o]
      const foundIndex = result.findIndex(r => r.id === id)
      result[foundIndex] = { ...result[foundIndex], IsOwnRcpt: result[foundIndex].IsOwnRcpt === 0 ? 1 : 0 }
      return result
    })
  }, [])


  const handleDialogOk = useCallback(async () => {

    const editRows = apiRef.current?.state?.editRows
    console.log("editRows", editRows)
    console.log("apiRef.current.state", apiRef.current?.state)
    if (editRows && Object.keys(editRows).length > 0) {
      // alertError("กรุณากด Enter เพื่อยืนยันการแก้ไขข้อมูลในตารางก่อน")
      // return
      await timeout(300)
    }

    if (dataTable.length === 0) {
      alertError("กรุณาเพิ่มข้อมูล การใช้เงิน")
      return
    }
    onFinish(dataTable)
    setDialogOpen(false)
  }, [onFinish, dataTable, setDialogOpen, apiRef])

  const addExpTableColumnsMemo = useMemo(() => {
    return addExpTableColumns({ handleChangeIsOwnRcpt, handleRemoveRow, whtTypeCombo: msData.whtTypeCombo, supplierCombo: msData.supplierCombo })
  }, [handleChangeIsOwnRcpt, handleRemoveRow, msData.whtTypeCombo, msData.supplierCombo])

  useEffect(() => {

    if (!dialogOpen) {
      setDataTable([])
      setExpId(null)
    }
  }, [dialogOpen])


  return (
    <Dialog
      open={dialogOpen}
      onClose={(e, reason) => {
        if (reason === "backdropClick") return
        setDialogOpen(false)
      }}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
      fullWidth maxWidth={isFromSubcontract ? "xl" : "lg"}
    >
      <DialogHeader handleDialogClose={() => setDialogOpen(false)}
        title={"เพิ่มรายการ"}
        onDeleteClick={null}
      />
      <DialogContent>
        <BoxFC pt={2} sx={{ gap: 1 }} >
          {jobOrdIds.length === 1 ? null : <Typography variant="h6" sx={{ textAlign: "center" }}>เพิ่มข้อมูลจำวน {jobOrdIds.length} ใบงาน</Typography>}
          <BoxFR>
            <BoxFC flex={1}>
              {user.AccTypId === ACC_TYP_EMP ?
                <BoxFR>
                  <ComboBox sx={{ width: 220 }} options={nonFavExp} label={"ค่าใช้จ่าย"}
                    selectedId={expId}
                    setSelectedId={(id) => setExpId(id)}
                  />
                  <Button variant="contained" onClick={handleAddFromCombo}><AddCircleRounded sx={{ mr: 1 }} /> เพิ่ม</Button>
                </BoxFR>
                : null
              }
              <Box height={user.AccTypId === ACC_TYP_EMP ? 300 : 360} sx={{
                ...sxSumColorClass,
                "& .ownRcpt": { bgcolor: blue[50] },
                "& .cusRcpt": { bgcolor: green[50] },
              }}>
                <DataGridCellExpand
                  apiRef={apiRef}
                  columnVisibilityModel={{ WhtPayrTyp: !!isFromSubcontract, WhtTypId: !!isFromSubcontract, SupId: !!isFromSubcontract, DocDte: !!isFromSubcontract }}
                  hideFooter
                  hideToolbar
                  rows={modDataTable}
                  columns={addExpTableColumnsMemo}
                  onCellEditCommit={handleEditCommit}
                  getRowClassName={getSumColorClassName}
                  experimentalFeatures={{ rowPinning: true }}
                  pinnedRows={{ bottom: [modDataTable.find(row => row.id === 0)] }}
                />
              </Box>
            </BoxFC>
            <BoxFC sx={{ gap: 0 }}>
              <Typography fontWeight="bold">ค่าใช้จ่ายที่ใช้บ่อย</Typography>
              <Box p={0.5} width={200} bgcolor={blueGrey[50]} height={335} sx={{ overflow: "auto" }}>
                {favExp.map(exp => (
                  <Button key={exp.id} sx={{ p: 0, justifyContent: "flex-start" }} onClick={() => { handleAddExp(exp) }}>
                    <AddCircleRounded sx={{ mr: 1 }} />
                    <Box sx={{ width: 150, py: 0.5, textAlign: "left", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}>
                      {exp.label}
                    </Box>
                  </Button>
                ))}
              </Box>
              {user.AccTypId === ACC_TYP_EMP ?
                <Typography variant="caption">(เพิ่มได้จาก ตั้งค่าส่วนตัว&gt;ตั้งค่าทั่วไป)</Typography>
                : null
              }
            </BoxFC>
          </BoxFR>
        </BoxFC>
      </DialogContent>
      <DialogFooter okText={"เพิ่มข้อมูล"}
        handleDialogClose={() => setDialogOpen(false)}
        handleDialogOk={handleDialogOk} />
    </Dialog>
  )
}

export default React.memo(AddExpenseTableDialog)